import PropTypes from 'prop-types';
import { addressPropTypes, fieldPropTypes, personNamePropTypes } from '../../../propTypes';

const paymentUserPropTypes = PropTypes.shape({
  address: addressPropTypes,
  emailAddress: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  fullName: personNamePropTypes,
  mailingAddress: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  mailingFullName: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  mobile: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  mobileCountryDialCode: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  phone: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  phoneCountryDialCode: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
});

export const makePaymentDetailsLoadPropTypes = PropTypes.shape({
  bankTransferPaymentsEnabled: PropTypes.bool,
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
  paymentUser: paymentUserPropTypes,
});

export const makePaymentDetailsLabelsPropTypes = PropTypes.shape({
  addressHeaderText: PropTypes.string,
  amountLabelText: PropTypes.string,
  bankTransferNoConsentMessage: PropTypes.string,
  bankTransferNoConfirmMessage: PropTypes.string,
  bankTransferExpiredMessage: PropTypes.string,
  bankTransferFailedMessage: PropTypes.string,
  detailsHeaderText: PropTypes.string,
  failedToRetrieveCheckoutProcessSettingsMessage: PropTypes.string,
  findAddressButtonText: PropTypes.string,
  invalidPaymentOptionMessage: PropTypes.string,
  paymentFieldsetTitle: PropTypes.string,
  paymentOptionBankTransferPayInFullText: PropTypes.string,
  paymentOptionCardPayInFullText: PropTypes.string,
  pcaPredictKey: PropTypes.string,
  sessionExpiredMessage: PropTypes.string,
  submitButtonText: PropTypes.string,
  titleOptions: PropTypes.arrayOf(PropTypes.string),
  totalToPayText: PropTypes.string,
  placeholderTexts: PropTypes.object,
  validationReviewFields: PropTypes.string,
  validationReviewAmount: PropTypes.string,
});
